import { getImageURL, IMAGE_SIZE } from 'helpers/FileUploadHelper';
import { useState } from 'react';

import { DefaultPlaceholderImage } from './Icons';

import type { ImageProps } from 'react-bootstrap';
interface LazyImageWrapperProps extends ImageProps {
  renderImageSize?: (typeof IMAGE_SIZE)[keyof typeof IMAGE_SIZE];
  defaultPlaceholderImage?: any;
  showOriginalImage?: boolean;
}
export default function LazyImageWrapper(props: LazyImageWrapperProps) {
  const {
    src,
    className,
    renderImageSize = IMAGE_SIZE.md,
    defaultPlaceholderImage = DefaultPlaceholderImage,
    showOriginalImage = false,
    ...rest
  } = props;
  const [loaded, setLoaded] = useState(false);
  const preview = src ? getImageURL(src, IMAGE_SIZE.sm) : defaultPlaceholderImage;
  const full = src
    ? showOriginalImage
      ? getImageURL(src)
      : getImageURL(src, renderImageSize)
    : defaultPlaceholderImage;
  return (
    <div className="blur-image-wrapper d-flex">
      {/* Blurred preview */}
      <img src={preview} className={`preview ${className} ${loaded ? 'loaded' : ''}`} {...rest} />

      {/* Full image */}
      <img
        src={full}
        loading="lazy"
        decoding="async"
        className={`full ${className ? className : ''} ${loaded ? 'loaded' : ''}`}
        {...rest}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
